'use client';

import { ElementRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import * as VisuallyHiddenPrimitive from '@radix-ui/react-visually-hidden';

const VisuallyHidden = ({
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof VisuallyHiddenPrimitive.Root> & {
  ref?: React.RefObject<ElementRef<typeof VisuallyHiddenPrimitive.Root> | null>;
}) => <VisuallyHiddenPrimitive.Root ref={ref} {...props} />;
VisuallyHidden.displayName =
  VisuallyHiddenPrimitive.Root.displayName || 'VisuallyHidden';

export { VisuallyHidden };
